













import {
    Vue, Component, Prop, PropSync, Mixins, Watch,
} from 'vue-property-decorator'
import wangEditor from 'wangeditor'
import config from '$config'

@Component
export default class WangEditor extends Vue {
    $refs: any

    @Prop({default: ''}) value!: string

    @Prop({default: false}) disabled!: boolean

    @Prop({default: -1}) num!: number

    @Prop({default: null}) menus!: any

    @Prop({default: '600px'}) height!: any

    @Prop({default: ''}) placeholder!: string

    showPlaceholder: boolean = false

    editor: any = ''

    @Watch('value')
    onValueChange(val) {
        if (val === '<p><br></p>') this.showPlaceholder = true
        else this.showPlaceholder = false
        if (this.editor && this.editor.txt) {
            if (val !== this.editor.txt.html()) {
                this.editor.txt.html(val)
            }
        }
    }

    @Watch('disabled')
    onDisabledChange(val) {
        if (val) {
            this.editor.$textElem.attr('contenteditable', false)
        } else {
            this.editor.$textElem.attr('contenteditable', true)
        }
    }

    @Watch('num')
    onNumChange(val) {
        this.editor.txt.html(this.value)
    }

    mounted() {
        let vm = this
        let editor = new wangEditor(vm.$refs.toolbar, vm.$refs.textarea)
        editor.customConfig.uploadImgServer = '/peanut/common/resource/icon/upload'
        editor.customConfig.uploadFileName = 'file'
        editor.customConfig.uploadImgTimeout = 60000
        editor.customConfig.zIndex = 5
        editor.customConfig.showLinkImg = false
        editor.customConfig.lang = {
            设置标题: 'Title',
            正文: 'p',
            字号: 'Font size',
            字体: 'Font',
            文字颜色: 'Font color',
            背景色: 'Background color',
            链接文字: 'Link text',
            链接: 'Link',
            上传图片: 'Upload image',
            网络图片: 'Network image',
            图片Link: 'Image url',
            上传: 'Upload',
            创建: 'Init',
            设置列表: 'Set the list',
            有序列表: 'Ordered list',
            无序列表: 'Unordered list',
            对齐方式: 'Alignment',
            靠左: 'Left',
            靠右: 'Right',
            居中: 'Center',
            // 还可自定添加更多
        }
        editor.customConfig.menus = this.menus ? this.menus : [
            'head',  // 标题
            'bold',  // 粗体
            'fontSize',  // 字号
            'fontName',  // 字体
            'italic',  // 斜体
            'underline',  // 下划线
            'strikeThrough',  // 删除线
            'foreColor',  // 文字颜色
            'backColor',  // 背景颜色
            'link',  // 插入链接
            'list',  // 列表
            'justify',  // 对齐方式
            'quote',  // 引用
            'emoticon',  // 表情
            'image',  // 插入图片
            'undo',  // 撤销
            'redo',  // 重复
        ]
        editor.customConfig.emotions = [
            {
                title: 'emoji',
                type: 'emoji',
                content: ['😀', '😃', '😄', '😁', '😆', '😅', '😂', '😊', '😇', '🙂', '🙃', '😉', '😓', '😪', '😴', '🙄', '🤔', '😬', '🤐'],
            },
        ]
        editor.customConfig.fontNames = [
            'Times New Roman',
            'Arial',
            'Tahoma',
            'Verdana',
        ]
        editor.customConfig.uploadImgHooks = {
            success(xhr, edit, result) {
                if (+result.code === 200) {
                    let html = '<img src="' + config.ossPrefix + result.data + '" alt="' + editor.customConfig.uploadFileName + '" style="width:100%"/>'
                    editor.cmd.do('insertHTML', html)
                } else {
                    vm.$message.error('upload failed')
                }
            },
            timeout(xhr, edit, result) {
                vm.$message.error('upload timeout')
            },
            error(xhr, edit, result) {
                vm.$message.error('upload failed')
            },
            customInsert(insertImg, result, edit) {
            },
        }
        editor.customConfig.onchange = function () {
            vm.$emit('input', editor.txt.html())
        }
        editor.create()
        if (this.disabled) {
            editor.$textElem.attr('contenteditable', false)
        }
        editor.config.placeholder = 'ewewe'
        this.editor = editor
        this.editor.txt.html(this.value)
    }
}
